import { createModule } from '../../createModule';
export const createPnlAttributionsAPI = createModule(({ http }) => {
    return {
        getState: async (params) => {
            const res = await http.get(`/v2/pnl-attributions/fund-state`, {
                params,
            });
            return res;
        },
        getRequestHistory: async (params) => {
            const res = await http.get(`/v2/pnl-attributions/history`, {
                params,
            });
            return res;
        },
        getAttributionsGrouped: async (params) => {
            const res = await http.post(`/v2/pnl-attributions/attributions-grouped`, {
                body: params,
            });
            return res;
        },
        getAttributions: async (params) => {
            const res = await http.post(`/v2/pnl-attributions/attributions`, {
                body: params,
            });
            return res;
        },
        beginValidation: async (body) => {
            const res = await http.post(`/v2/pnl-attributions/attributions/start`, { body });
            return res;
        },
        refreshAttributions: async (body) => {
            const res = await http.post(`/v2/pnl-attributions/attributions/refresh`, { body });
            return res;
        },
        publishAttributions: async (body) => {
            const res = await http.post(`/v2/pnl-attributions/attributions/publish`, { body });
            return res;
        },
        position: {
            adjust: async (body) => {
                const res = await http.post('/v2/pnl-attributions/position/adjust', { body });
                return res;
            },
            addComponent: async (body) => {
                const res = await http.post('/v2/pnl-attributions/position/addition', { body });
                return res;
            },
        },
        trade: {
            adjust: async (body) => {
                const res = await http.post('/v2/pnl-attributions/trade/adjust', { body });
                return res;
            },
            addComponent: async (body) => {
                const res = await http.post('/v2/pnl-attributions/trade/addition', { body });
                return res;
            },
        },
        approveRequest: async (body) => {
            const res = await http.post('/v2/pnl-attributions/request/approve', { body });
            return res;
        },
        rejectRequest: async (body) => {
            const res = await http.post('/v2/pnl-attributions/request/reject', { body });
            return res;
        },
    };
});
